// extracted by mini-css-extract-plugin
module.exports = {"root":"appLayout_root__2CEyG","iconMenu":"appLayout_iconMenu__1A2KY","siteLayout":"appLayout_siteLayout__GdsoC"};